<div class="items-list">
    <ul>
        <li *ngFor="let item of filteredItems">
            <mat-checkbox [checked]="isItemSelected(item)"
                          (change)="onItemSelected(item)">
                <span class="label">
                    {{ item.text ? item.text.fullLabel : item.code }}
                    <app-tooltip [text]="item.text ? item.text.detail : item.description"></app-tooltip>
                </span>
            </mat-checkbox>
        </li>
    </ul>
</div>